import {
    JOB_WORK_ORDER_REQUEST,
    JOB_WORK_ORDER_SUCCESS,
    JOB_WORK_ORDER_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const JobWorkOrderAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: JOB_WORK_ORDER_REQUEST,
        payload: true,
      });
      
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/add_work_order`,
        method: "POST",
        data: data, 
        headers: {
          "content-type": "application/json",
         
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(jobworkorderPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: JOB_WORK_ORDER_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
          toast.error("Failed To jobworkorderPre!");
        });
    };
  };
  export const jobworkorderPre = (data) => {
    toast.success("Successfully!");
    sessionStorage.clear();
    return {
      type: JOB_WORK_ORDER_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };